<script>
  // @ts-nocheck

  import { onMount } from "svelte";
  import Library from "./library/Library.svelte";
  import {
    soundBoard,
    librarySceneSelected,
    screenLayout,
    ScreenLayouts,
  } from "./store";
  import { SortableList } from "@jhubbardsf/svelte-sortablejs";
  import {
    sortableForceFallbackForFirefox,
    sortablePreventDOMManipulation,
  } from "./genericHandlers";
  import { SceneKinds } from "./Soundboard";
  import FreeformScene from "./FreeformScene.svelte";
  import GuidedScene from "./GuidedScene.svelte";
  import WindowData from "./WindowData.svelte";
  import SceneList from "./SceneList.svelte";
  import Tutorial from "./tutorial/Tutorial.svelte";
  import { Tutorial as TutorialSequence } from "./tutorial/Tutorial";

  onMount(async () => {
    fetch("/app/soundboard/board/json")
      .then((response) => response.json())
      .then((data) => {
        const parsed = JSON.parse(data);
        soundBoard.replace(parsed);
      })
      .catch((error) => {
        return [];
      });
  });

  let draggingFromDrawer = false;
  librarySceneSelected.subscribe((newVal) => {
    draggingFromDrawer = newVal !== null;
  });

  const addScene = (kind) => {
    soundBoard.AddScene(kind);
  };
  const handleLaneSort = (evt) => {
    sortablePreventDOMManipulation(evt);
    if (!draggingFromDrawer) {
      soundBoard.MoveScene(evt.oldIndex, evt.newIndex);
    }
  };

  const handleSceneAdd = (evt) => {
    sortablePreventDOMManipulation(evt);
    soundBoard.AddExistingRawScene($librarySceneSelected.scene, evt.newIndex);
  };

  const handleSceneDuplicate = (evt, scene, idx) => {
    const newScene = structuredClone(scene);
    newScene.name += " (Copy)";
    soundBoard.AddExistingRawScene(newScene, idx + 1);
  };

  const handleEnd = (evt) => {
    sortablePreventDOMManipulation(evt);
  };
</script>

<WindowData />
<main class="soundboard" id="soundboard-main">
  {#if $screenLayout !== ScreenLayouts.Mobile}
    <SortableList
      class="TODO BL:"
      handle=".soundboard-lane"
      filter=".unsortable"
      onSort={handleLaneSort}
      onAdd={handleSceneAdd}
      onEnd={handleEnd}
      group={{ name: "scenes" }}
      animation={250}
    >
      <SceneList duplicateCallback={handleSceneDuplicate} />
    </SortableList>
  {:else}
    <SceneList duplicateCallback={handleSceneDuplicate} />
  {/if}
  <div class="add-scene-container">
    <button
      type="button"
      class="outline contrast full-w full-h center-contents-vh color-font font-size-1-5-rem"
      on:click={() => addScene(SceneKinds.Guided)}
      data-tooltip="Start a new scene using our template."
    >
      <div class="add-scene-button">Add Scene</div>
    </button>
  </div>
  {#if $screenLayout !== ScreenLayouts.Mobile && !sortableForceFallbackForFirefox()}
    <div
      class="container center-contents-h"
      on:click={() => new TutorialSequence().start()}
    >
      <div>
        <p>
          You can always
          <u>click here </u>
          to run the tutorial.
        </p>
      </div>
    </div>
  {/if}
  <Library />
</main>
<div style="height: 50vh"></div>
